export enum Layers {
  BACKGROUND = 0,         // 기본
  BABYLON_CANVAS = 10000,  // 바빌론 캔버스와 연동되어 그려져야 하는 레이어 
  UI_CONTENTS = 20000,     // 기본적인 UI 컴포넌트 레이어
  UI_MODAL = 40000,        // 모달, 다이얼로그 등 기본적인 UI 위에 그려지는 레이어
  BABYLON_DEBUG = 50000,   // 디버깅을 위한 개발자용 UI(Inspector, DebugPanel...)
}
